import { render, staticRenderFns } from "./BellOnIcon.vue?vue&type=template&id=4d6ee2bb&"
import script from "./BellOnIcon.vue?vue&type=script&lang=ts&"
export * from "./BellOnIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports